var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"section-title-wrap text-center section-space--mb_60"},[_c('h2',{staticClass:"font-weight--bold mb-15 wow move-up"},[_vm._v(_vm._s(_vm.sectionTitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }